import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSchedules(params) {
	return clientSupplier.get("api-supplier/po-schedule/data", {
		params: params,
	});
}

function getDetailSchedule(params) {
	return clientSupplier.get("api-supplier/po/detail", {
		params: {
			po_code : params
		},
	});
}

function exportSchedules(params) {
	return clientSupplier.get("api-supplier/po-schedule/export", {
		params: params,
	});
}

export default {
	getSchedules,
	getDetailSchedule,
	exportSchedules
};